// StepSection.js
import React, { useEffect, useRef, useState } from "react";
import {dashboardL,
	dashboardImg,
	adsImg,
	action,
	product,
	geo,
	timeImg,
  pricBg, } from "../../../../../images/index.js";
import { motion, AnimatePresence } from "motion/react";
import { Link } from "react-router-dom";
import StepSectionDesign from "./StepDesign.js";


const features = [
  {
    title: "Smart Dashboard",
    description:
      "One-page view of your entire business.",
    image: dashboardImg,
  },
  {
    title: "Ad Insights",
    description:
      "Real-time Ad Insights to measure reach, engagement & ROI in seconds.",
    image: adsImg,
  },
  {
    title: "Geo Sales Insights",
    description:
      "See where your business wins and where it leaks.",
    image: geo,
  },
  {
    title: "Time-based Performance",
    description:
      "Discover which hour, day, or week drives sales.",
    image: timeImg,
  },
  {
    title: "Product Growth Tracker",
    description:
      "Toggle week or month to uncover growth streaks.",
    image: product,
  },
  {
    title: "Action Recommendations",
    description:
      "Your real-time business health tracker.",
    image: action,
  },
];

const StepSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [dotTop, setDotTop] = useState("-10px");

  const featureRefs = useRef([]);
  const containerRef = useRef(null);
  const sliderRef = useRef(null);

  // 🟣 Smoothly calculate the dot's vertical position
  useEffect(() => {
    if (!containerRef.current || !featureRefs.current[activeIndex]) return;

    const activeEl = featureRefs.current[activeIndex];
    const containerTop =
      containerRef.current.getBoundingClientRect().top + window.scrollY;
    const elementTop = activeEl.getBoundingClientRect().top + window.scrollY;
    const offset = activeIndex === 0 ? 10 : 30;

    const newTop = `${elementTop - containerTop - 30 + offset}px`;
    setDotTop(newTop);
  }, [activeIndex]);

  //  Scroll listener: pick the item closest to viewport center (fixes “jump to 0”)
  useEffect(() => {
    const handleScroll = () => {
      let closestIndex = 0;
      let minDistance = Infinity;
      const middleY = window.scrollY + window.innerHeight / 2;

      featureRefs.current.forEach((el, index) => {
        if (!el) return;
        const rect = el.getBoundingClientRect();
        const elementY = rect.top + window.scrollY + rect.height / 2;
        const distance = Math.abs(elementY - middleY);
        if (distance < minDistance) {
          minDistance = distance;
          closestIndex = index;
        }
      });

      setActiveIndex(closestIndex);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  //  Handle mobile horizontal slider
  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;
    const handleScroll = () => {
      const scrollLeft = slider.scrollLeft;
      const cardWidth = slider.scrollWidth / features.length;
      const index = Math.round(scrollLeft / cardWidth);
      setActiveIndex(Math.min(index, features.length - 1));
    };
    slider.addEventListener("scroll", handleScroll);
    return () => slider.removeEventListener("scroll", handleScroll);
  }, []);

    const floatingItems = [
    {
      text: "User Friendly Visualization",
      className: "floating-tag top-left",
    },
    {
      text: "Actionable Alerts",
      className: "floating-tag top-right",
    },
    {
      text: "Comprehensive Coverage",
      className: "floating-tag bottom-left",
    },
    {
      text: "Real-Time Insights",
      className: "floating-tag bottom-right",
    },
  ];


  return (
    <>
      <StepSectionDesign />
      <div className="mobile-slider-wrapper">
        {/* Cards Slider */}
        <motion.div
          className="cards-wrapper"
          ref={sliderRef}
          onScroll={() => {
            if (sliderRef.current) {
              scrollX.set(sliderRef.current.scrollLeft);
            }
          }}
        >
          <div className="cards-track">
            {features.map((card, index) => (
              <motion.div
                key={index}
                className={`card ${index === activeIndex ? "active" : ""}`}
              >
                <h3 className="card-title">{card.title}</h3>
                <p className="card-description">{card.description}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
        <div className="text-center mb-4">
          <motion.img
            key={features[activeIndex].image}
            src={features[activeIndex].image}
            alt={features[activeIndex].title}
            className="img-fluid step-image"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
          />
        </div>
      </div>
    </>
  );
};

export default StepSection;
